<layout-sidebar>
  <div class="main">
    <h2 class="font-weight-bold">Sign Up for KnowYourDrive</h2>
    <br />
    <p>
      We're proud to partner with Automatic&trade;, an innovative company connecting cars on the
      road to the internet and empowering drivers with knowledge about themselves and their cars.
      Learn to be safer and drive smarter, and we'll reward you with savings on your car insurance!
      Automatic&trade; will send you the plug-in adapter for your car that monitors driving behavior
      and helps you learn safe driving habits. You'll start out with a 5% introductory insurance
      discount, and depending on your driving habits, you could earn up to a 40% program discount*.
    </p>
    <form [formGroup]="kydForm" (ngSubmit)="submitForm()" class="pad-top-20">
      <fieldset class="radio">
        <p class="margin-bottom-10">
          <i
            >KnowYourDrive requires a smartphone to keep track of the good driving habits that can
            help you earn a discount. Do you have a smartphone?
          </i>
        </p>
        <span class="inline-block pad-right-30">
          <input type="radio" formControlName="enroll" id="opt-in" value="yes" />
          <label for="opt-in"> Yes </label>
        </span>
        <span class="inline-block">
          <input type="radio" formControlName="enroll" id="opt-out" value="no" />
          <label for="opt-out"> No </label>
        </span>
      </fieldset>
      <hr aria-hidden="true" />
      @if (kydForm.controls['enroll'].value == 'no') {
        <div>
          <div class="pad-top-20 pad-bottom-20">
            Unfortunately, without a smartphone, you won’t be able to participate in KnowYourDrive.
            If you have any questions, please contact your agent or call us at (800) 692-6326, ext.
            75230.
          </div>
        </div>
      }
      @if (kydForm.controls['enroll'].value != 'yes') {
        <div>
          <div class="row callToAction">
            <span class="md-float-right">
              <button ds-button type="button" class="-outline" (click)="cancel()">
                Back To Policy
              </button>
            </span>
          </div>
        </div>
      }
      @if (kydForm.controls['enroll'].value == 'yes') {
        <div>
          <div>
            <h4 class="pad-top-20 pad-bottom-20 font-weight-bold">
              Which vehicles are you adding the KnowYourDrive discount to?
            </h4>
            <div class="row">
              <div class="flex self-center pad-bottom-10">
                <div class="flex self-center">
                  <div [hidden]="risks.length <= 1">
                    <input
                      class="checkbox"
                      type="checkbox"
                      formControlName="allRisks"
                      id="allRisks"
                      (change)="selectAll($event)"
                    />
                    <label class="checkbox-label" for="allRisks"></label>
                  </div>
                  <div [hidden]="risks.length > 1" class="pad-right-40"></div>
                </div>
                <span class="column seven pad-right-10"
                  ><h3 class="font-weight-semibold">
                    @if (risks.length > 1) {
                      Select All
                    }
                    Vehicles
                  </h3></span
                >
                <span class="column four"><h3 class="font-weight-semibold">Policy Number</h3></span>
              </div>
            </div>
            @for (risk of risks; track risk; let isFirst = $first; let isLast = $last) {
              <div class="row">
                <div class="flex self-center eligibleRisk" [ngClass]="{ lastRisk: isLast }">
                  <div class="flex self-center">
                    <input
                      class="checkbox"
                      type="checkbox"
                      [formControlName]="risk.id"
                      [attr.id]="risk.id"
                      (change)="riskSelected(risk)"
                    />
                    <label class="checkbox-label" [attr.for]="risk.id"></label>
                  </div>
                  <span class="column seven pad-right-10"
                    ><h4>{{ risk.description }}</h4></span
                  >
                  <span class="column four"
                    ><h4>{{ risk.policy | prettyPolicyNum }}</h4></span
                  >
                </div>
              </div>
            }
          </div>
          <app-kyd-ship-tos
            [kydForm]="kydForm"
            [risks]="selectedRisks"
            [hidden]="!selectedRisks.length"
            (addressSelection)="addressSelection($event)"
          >
          </app-kyd-ship-tos>
          <div class="row" [hidden]="!selectedRisks.length">
            <h4 class="column twelve pad-top-30 font-weight-bold">
              Agree to the Terms &amp; Conditions
            </h4>
            <div class="column twelve">
              <span class="flex items-center">
                <input class="checkbox" type="checkbox" formControlName="terms" id="terms" />
                <label for="terms" class="checkbox-label">
                  <p>
                    I have read and agree to the KnowYourDrive
                    <a dsRouterLink="/terms/know-your-drive" target="_blank"
                      >Terms &amp; Conditions</a
                    >
                  </p>
                </label>
              </span>
            </div>
          </div>
          <div class="row callToAction">
            <span class="md-float-right">
              <a class="pad-horizontal-20" (click)="cancel()">Cancel</a>
              <button
                ds-button
                type="submit"
                class="-outline"
                [disabled]="!formValid || !(roleService.isAuthorized(roleName) | async)"
              >
                Submit
              </button>
            </span>
          </div>
        </div>
      }
      <div class="disclaimer">
        *Program discounts will vary based on driving behavior. The KnowYourDrive discount applies
        only to the following variable coverages, which are typical for most auto policies: bodily
        injury liability, property damage liability, collision and comprehensive, medical expense,
        and personal injury protection. To refresh your understanding of these coverages, visit
        amfam.com/insurance/car/coverages. Additionally, the discount does not apply to fixed fees
        that are part of your policy.
      </div>
    </form>
  </div>
  <aside class="main-aside"><links-agents-sidebar></links-agents-sidebar></aside>
</layout-sidebar>
